import LocationCreate from './LocationCreate'
export {LocationCreate}
export default LocationCreate
